// extracted by mini-css-extract-plugin
export var searchHeader = "_ab-0";
export var searchHeaderDark = "_ab-1";